import script from "./ExcerptOverlay.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExcerptOverlay.vue?vue&type=script&setup=true&lang=ts"

import "./ExcerptOverlay.vue?vue&type=style&index=0&id=4683d355&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4683d355"]])

export default __exports__